import type { Form } from 'factorial-form'

export const formGetDirtyFields = (form: Form) => {
  return Object.entries(form.fields)
    .filter(([_key, field]) => field.isDirty)
    .map(([key, _field]) => key)
}
